import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router';
import { paths } from 'src/routes/paths';
import { useThemeStore } from 'src/store/products/theme.store';
import * as Yup from 'yup';

const STATUS_OPTIONS = ['active', 'inactive'];
const STATUS_LABEL = ['Ativo', 'Inativo'];

const MULTIPLE_OPTIONS = [true, false];
const MULTIPLE_LABEL = ['Sim', 'Não'];

export default function useThemeDetails() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();
  const {
    loadingThemeDetails,
    themeDetails,
    getThemeDetails,
    resetThemeDetails,
    updateTheme,
    createTheme,
  } = useThemeStore();
  const { pathname } = useLocation();
  const isEdit = pathname.includes('edit');

  useEffect(() => {
    if (id) {
      getThemeDetails(id);
    } else {
      resetThemeDetails();
    }
  }, []);

  const defaultValues = useMemo(
    () => ({
      name: themeDetails?.name || '',
      multipleRedeem: !!themeDetails?.multipleRedeem,
      redeemQuantity: themeDetails?.redeemQuantity || 0,
      status: themeDetails?.status || 'active',
    }),
    [themeDetails]
  );

  const promotionSchema = Yup.object().shape({
    name: Yup.string().required('Campo obrigatório!'),
    multipleRedeem: Yup.boolean(),
    redeemQuantity: Yup.number().when('multipleRedeem', {
      is: false,
      then: (schema) => schema.nullable(),
      otherwise: (schema) =>
        schema.required('Campo obrigatório').min(1, 'O valor deve ser maior que zero'),
    }),
    status: Yup.string(),
  });

  const methods = useForm({
    resolver: yupResolver(promotionSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    watch,
    formState: { isSubmitting },
  } = methods;

  const values = watch();

  useEffect(() => {
    if (defaultValues) {
      reset(defaultValues);
    }
  }, [themeDetails, reset, defaultValues]);

  const onSubmit = handleSubmit(async (data: any) => {
    try {
      const updatedData = {
        id: isEdit ? id : null,
        name: data.name,
        multipleRedeem: data.multipleRedeem,
        redeemQuantity: data.redeemQuantity,
        status: data.status,
      };

      if (isEdit) {
        await updateTheme(updatedData);
        enqueueSnackbar('Tema atualizado com sucesso!');
        navigate(`${paths.dashboard.themesCategoriesList}?tab=themes`);
      } else {
        await createTheme(updatedData);
        enqueueSnackbar('Tema criado com sucesso!');
        navigate(`${paths.dashboard.themesCategoriesList}?tab=themes`);
      }
    } catch (error) {
      console.error(error);
    }
  });

  return {
    isEdit,
    loadingThemeDetails,
    methods,
    values,
    isSubmitting,
    STATUS_OPTIONS,
    STATUS_LABEL,
    MULTIPLE_OPTIONS,
    MULTIPLE_LABEL,
    onSubmit,
    navigate,
    enqueueSnackbar,
  };
}
